export class Immunizations {
  Id: number;
  Name: string;
  ExemptCode: string;
  ExemptCodeId: string;
  VaccineTypeId: string;
  ExemptDate: Date;
  Date1: Date;
  Date2: Date;
  Date3: Date;
  Date4: Date;
  Date5: Date;
  Date6: Date;
  Date7: Date;
  Date8: Date;
  Date9: Date;
  Date10: Date;
  Date11: Date;
  Date12: Date;
  Date13: Date;
  Date14: Date;
  Date15: Date;
  Date16: Date;
  Date17: Date;
  Date18: Date;
  Date19: Date;
  Date20: Date;
  ImmunizationsNote: string;
}

export class Medications {
  Id: number;
  Medication: string;
  Frequency: string;
  StartDate: Date;
  EndDate: Date;
  Dose: string;
  SchoolAuthorisedToAdminister: string;
  Pharmacy: string;
  Phone: string;
  RxNumber: string;
  Doctor: string;
  Comments: string;
}

export class Doctors {
  Id: number;
  DoctorName: string;
  Address: string;
  Telephone: string;
  Email: string;
  Type: string;
  TypeCode: string;
  PhysiciansId: number;
  PhysicianTypeId: number;
  Comment: string;
  PhysicianName: string;
  PracticeName: string;
  DateStart: Date;
  DateEnd: Date;
  //// Non DTO Field ////

  PhysicianDescription: string;
  DoctorType: string;
}

export class HealthVisitLog {
  Id: number;
  Date: Date;
  TimeIn: string;
  TimeOut: string;
  VisitReason: string;
  Action: string;
  SentTo: string;
}

export class Insurance {
  Id: number;
  PhysiciansId: number;
  PhysicianTypeId: string;
  InsuranceCompany: string;
  InsuranceStartDate: Date;
  InsuranceEndDate: Date;
  Policy: string;
  Primary: string;
  Phone: string;
  Comment: string;

  constructor() {
    this.Id = 0;
    this.PhysiciansId = 0;
    this.PhysicianTypeId = '2'; // Insurance
    this.InsuranceCompany = '';
    this.InsuranceStartDate = null;
    this.InsuranceEndDate = null;
    this.Policy = '';
    this.Primary = '';
    this.Phone = '';
    this.Comment = '';
  }
}

export class Screening {
  Id: number;
  ScreeningType: string;
  Screenings: IndividualScreenings[];
}

export class IndividualScreenings {
  HealthScreeningId: number;
  ScreeningName: string;
  SeriesName: string;
  ScheduledDate: Date;
  ScreenedDate: Date;
  Result: string;
  ResultCode: string;
  Referral: string;
  Comments: string;
  Height: number;
  Weight: number;
  BMI: number;
  BMIPercentile: number;
  ReferralStatus: string;
  SportsScreening: boolean;
}

export class CodeLegend {
  CodeID: number;
  Code: string;
  Definition: string;
  CodeType: string;
  ScreeningType: string;
}

export class HealthNotes {
  StudentId: number;
  MedicalImmunizationNote: string;
  MedicalConditionNote: string;
  MedicalPhysicianInformationNote: string;
  MedicalInsuranceNote: string;
  RecordStatus: string;
}
